import request from '@/utils/request'

// 获取设备列表
export const getDeviceList = (params: any) =>
  request({
    url: '/manage/device',
    method: 'get',
    params
  })
// 设备状态更改
export const setChangeStatus = (data: any) =>
  request({
    url: `/manage/device/${data.device_id}/change-status`,
    method: 'patch',
    data
  })

// 发送邮箱验证码
export const getVerifyCode = (data: any) =>
  request({
    url: `/manage/device/${data}/send_email_verify_code`,
    method: 'post'
  })

// 信任新设备
export const setTrustDevice = (data: any) =>
  request({
    url: `/manage/device/${data.device_id}/trust_device`,
    method: 'patch',
    data
  })
